import { CircularProgress, Stack } from '@mui/material';
import { Suspense, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import useUnitProvider from '/@/core/context/unit';
import settings from '/@/core/settings';
import { setView } from '/@/store/nav/actions';
import { parseParams, parseQuerystring } from '/@/utils/router';
import { pushToGTMGA } from '../../store/tracking/utils';

export default function ViewContext(props) {
    const units = useUnitProvider();
    const dispatch = useDispatch();
    const location = useLocation();
    const params = useParams();
    const theme = useMemo(() => {
        const viewTheme = props.viewsByName[props.name].theme;

        let currentBrand = props.brands[viewTheme]; //TODO: BRAND
        if (currentBrand) {
            currentBrand = currentBrand[0];
        }

        return (currentBrand && currentBrand.theme) || props.theme || settings.app.theme;
    }, [props]);
    const trackPageView = (props) => {
        if (props.viewsByName[props.name].noPageViewTracking) return;

        const { pathname, search } = props.location;

        const event = {
            action: 'page_view',
            page_path: pathname + search,
            page_location: window.location.href,
        };

        pushToGTMGA(event);
    };
    useEffect(() => {
        dispatch(setView({ name: props.name, type: props.type }));
    }, []);

    useEffect(() => {
        trackPageView(props);
    }, [location.pathname, location.search]);

    const { viewProps, component: ViewComponent } = props;
    // TO-DO: This props should be forwarded inside a container variable
    // so they are easier to reason about in child containers and also to avoid
    // overwrites.

    const querystring = useMemo(() => parseQuerystring(location.search), [location.search]);
    const parsedParams = useMemo(() => parseParams(params), [params]);
    return (
        <Suspense
            fallback={
                <Stack sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                </Stack>
            }
        >
            <ViewComponent location={location} {...viewProps} {...querystring} {...parsedParams} />
        </Suspense>
    );
}
